// Tool registry — the single source of truth for the toolbox. The header Tools
// menu, the Home launcher grid, and the Dashboard tabs all render from this list.
// Add a tool here once and it appears everywhere. Mark `comingSoon: true` to list
// it (with a "Soon" badge) before it ships.
//
// Fields:
//   id            stable key
//   label         short name ("Short link")
//   desc          one-liner for launcher cards
//   icon          emoji shown in menus/cards
//   createRoute   dedicated page for the create tool ("/shorten")
//   createLabel   CTA label ("Shorten a link")
//   dashboardTab  slug for the Dashboard tab ("links"); omit if not manageable
//   dashboardLabel tab label ("Links")
//   comingSoon    hide from Dashboard + disable the create page

export const tools = [
  {
    id: 'links',
    label: 'Short link',
    desc: 'Shorten any URL and track it',
    icon: '🔗',
    createRoute: '/shorten',
    createLabel: 'Shorten a link',
    dashboardTab: 'links',
    dashboardLabel: 'Links',
    comingSoon: false,
  },
  {
    id: 'files',
    label: 'File share',
    desc: 'Share a file up to 5 GB',
    icon: '📎',
    createRoute: '/share',
    createLabel: 'Share a file',
    dashboardTab: 'files',
    dashboardLabel: 'Files',
    comingSoon: false,
  },
  {
    id: 'paste',
    label: 'Paste bin',
    desc: 'Share text & code snippets',
    icon: '📋',
    createRoute: '/paste',
    createLabel: 'New paste',
    dashboardTab: 'pastes',
    dashboardLabel: 'Pastes',
    comingSoon: false,
  },
];

// Tools that are live (usable now).
export const liveTools = tools.filter((t) => !t.comingSoon);

// Tools that show a manage tab in the Dashboard.
export const dashboardTools = tools.filter((t) => t.dashboardTab && !t.comingSoon);

export function toolByTab(tab) {
  return tools.find((t) => t.dashboardTab === tab);
}
